import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Robot.css';
import {playSound, SOUND_LONG, SOUND_SHORT} from './SoundManager.js';

// This uses Webpack to bundle the files.
// For a comparison of this approach vs the public folder, see:
// https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-the-public-folder
import Robot1 from './assets/robots/01A.png';
import Robot2 from './assets/robots/02A.png';
import Robot3 from './assets/robots/03A.png';
import Robot4 from './assets/robots/04A.png';
import Robot5 from './assets/robots/05A.png';
import Robot6 from './assets/robots/06A.png';
import Robot7 from './assets/robots/07A.png';
import Robot8 from './assets/robots/08A.png';
import Robot9 from './assets/robots/09A.png';

import Robot1_singing from './assets/robots/01B.png';
import Robot2_singing from './assets/robots/02B.png';
import Robot3_singing from './assets/robots/03B.png';
import Robot4_singing from './assets/robots/04B.png';
import Robot5_singing from './assets/robots/05B.png';
import Robot6_singing from './assets/robots/06B.png';
import Robot7_singing from './assets/robots/07B.png';
import Robot8_singing from './assets/robots/08B.png';
import Robot9_singing from './assets/robots/09B.png';

import Robot1_success from './assets/robots/01B2.png';
import Robot2_success from './assets/robots/02B2.png';
import Robot3_success from './assets/robots/03B2.png';
import Robot4_success from './assets/robots/04B2.png';
import Robot5_success from './assets/robots/05B2.png';
import Robot6_success from './assets/robots/06B2.png';
import Robot7_success from './assets/robots/07B2.png';
import Robot8_success from './assets/robots/08B2.png';
import Robot9_success from './assets/robots/09B2.png';

import Robot1_error from './assets/robots/01C.png';
import Robot2_error from './assets/robots/02C.png';
import Robot3_error from './assets/robots/03C.png';
import Robot4_error from './assets/robots/04C.png';
import Robot5_error from './assets/robots/05C.png';
import Robot6_error from './assets/robots/06C.png';
import Robot7_error from './assets/robots/07C.png';
import Robot8_error from './assets/robots/08C.png';
import Robot9_error from './assets/robots/09C.png';

export const base_robot_images = [
    Robot1,
    Robot2,
    Robot3,
    Robot4,
    Robot5,
    Robot6,
    Robot7,
    Robot8,
    Robot9,
];

const robot_configs = [
    {
        image: Robot1,
        singing_image: Robot1_singing,
        success_image: Robot1_success,
        error_image: Robot1_error,
    },
    {
        image: Robot2,
        singing_image: Robot2_singing,
        success_image: Robot2_success,
        error_image: Robot2_error,
    },
    {
        image: Robot3,
        singing_image: Robot3_singing,
        success_image: Robot3_success,
        error_image: Robot3_error,
    },
    {
        image: Robot4,
        singing_image: Robot4_singing,
        success_image: Robot4_success,
        error_image: Robot4_error,
    },
    {
        image: Robot5,
        singing_image: Robot5_singing,
        success_image: Robot5_success,
        error_image: Robot5_error,
    },
    {
        image: Robot6,
        singing_image: Robot6_singing,
        success_image: Robot6_success,
        error_image: Robot6_error,
    },
    {
        image: Robot7,
        singing_image: Robot7_singing,
        success_image: Robot7_success,
        error_image: Robot7_error,
    },
    {
        image: Robot8,
        singing_image: Robot8_singing,
        success_image: Robot8_success,
        error_image: Robot8_error,
    },
    {
        image: Robot9,
        singing_image: Robot9_singing,
        success_image: Robot9_success,
        error_image: Robot9_error,
    },
];

export const ROBOT_VISUAL_STATES = {
    DEFAULT: 'default',
    SINGING: 'singing',
    SUCCESS: 'success',
    ERROR: 'error',
}

export default class Robot extends Component {
    constructor(props) {
        super(props);
        this.sound = null;
    }

    play_sound(sound_type, soundjs_options={}) {
        this.stop_sound();
        this.sound = playSound(sound_type, this.props.number, soundjs_options);
        this.sound.on('complete', () => {
            this.stop_sound();
            // the value of this.sound is used in display logic
            this.forceUpdate();
        }, null, true);
    }
    stop_sound() {
        if (this.sound) {
            this.sound.stop();
            this.sound = null;
        }
    }

    componentWillReceiveProps(nextProps) {
        const {should_play_sound_once, is_playing_continuously} = this.props;

        if (nextProps.is_playing_continuously && !is_playing_continuously) {
            this.play_sound(nextProps.long_sound ? SOUND_LONG : SOUND_SHORT, {loop: -1});
        }
        else if (is_playing_continuously && !nextProps.is_playing_continuously) {
            this.stop_sound();
        }

        // This check must come after is_playing_continuously, so that in a single 
        // update we can stop continuous playback and initiate a single playback
        if (nextProps.should_play_sound_once && !should_play_sound_once) {
            this.play_sound(nextProps.long_sound ? SOUND_LONG : SOUND_SHORT);

            // Notice - this delays reading the value of on_sound_complete until the sound stops
            this.sound.on('complete', () => {
                const {on_sound_complete} = this.props;
                if (on_sound_complete) {
                    on_sound_complete();
                }
            }, null, true);
        }
    }

    componentWillUnmount() {
        this.stop_sound();
    }

    get_src() {
        const {number, visual_state} = this.props;
        const config = robot_configs[number - 1];

        switch (visual_state) {
            case ROBOT_VISUAL_STATES.SINGING :
                return config.singing_image;
            case ROBOT_VISUAL_STATES.SUCCESS :
                return config.success_image;
            case ROBOT_VISUAL_STATES.ERROR :
                return config.error_image;
        }
        return config.image;
    }

    render() {
        const {number, large} = this.props;
        // const is_singing = Boolean(this.sound) || visually_singing;
        // const config = robot_configs[number - 1];
        // const src = error ? config.error_image : (is_singing ? config.singing_image : config.image);
        return <img src={this.get_src()} alt={"Robot number " + number} className={classnames('Robot', {'Robot-small': !large})} />
    }
}

Robot.propTypes = {
    // all robots are identified by a number: 1 - 12
    number: PropTypes.number.isRequired,

    large: PropTypes.bool.isRequired,
  
    // These affect audio only
    // You must toggle this from false to true to make the robot play.
    // Once started, there is no way to stop its sound.
    should_play_sound_once: PropTypes.bool,
    on_sound_complete: PropTypes.func,
    is_playing_continuously: PropTypes.bool,
    long_sound: PropTypes.bool,

    visual_state: PropTypes.string,

    is_shaking: PropTypes.bool,
};
Robot.defaultProps = {
    visual_state: ROBOT_VISUAL_STATES.DEFAULT,
}


// WEBPACK FOOTER //
// ./src/Robot.js